import { Avatar, Box } from "@mui/material";
import React, { useEffect } from "react";
import Footer from "../component/Footer";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { userSignInAction } from "../redux/actions/userAction";
import { Link, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup
    .string("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
});

const LogIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo, loading } = useSelector((state) => state.signIn);
  useEffect(() => {
    window.scroll(0, 0);
    if (userInfo) {
      navigate("/");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      dispatch(userSignInAction(values, navigate));
    },
  });

  return (
    <>
      <section
        className="section-hero  inner-page"
        id="home-section"
        style={{
          backgroundColor: "rgb(64,64,64)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <h1
                className="text-white"
                style={{
                  fontSize: "4rem",
                  fontWeight: "400",
                }}
              >
                Login
              </h1>
              <div className="custom-breadcrumbs">
                <Link
                  style={{
                    color: "white",
                  }}
                  to="/"
                >
                  Home
                </Link>

                <span className="mx-2 slash">/</span>
                <span className="text-white">
                  <strong>Log in</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="site-section2"
        style={{
          paddingBottom: "100px",
          paddingTop: "50px",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <div
          style={{
            padding: "5%",
            boxShadow: "5px 5px 8px #D5D5E2",
          }}
        >
          <div>
            <form onSubmit={formik.handleSubmit} class="contain-login">
              <div class="row form-group">
                <div class="col-md-12 mb-3 mb-md-0">
                  <h2 class="mb-4">Log In To JobBoard</h2>
                  <label class="text-black" for="email">
                    Email
                  </label>
                  <input
                    type="text"
                    id="email"
                    className="form-control"
                    placeholder="Email address"
                    name="email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    style={{
                      borderColor:
                        formik.errors.email && formik.touched.email
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.email && formik.touched.email
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.email && formik.touched.email && (
                    <p style={{ color: "red" }}>{formik.errors.email}</p>
                  )}
                </div>
              </div>
              <div className="row form-group mb-4">
                <div className="col-md-12 mb-3 mb-md-0">
                  <label className="text-black" for="password">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    placeholder="Password"
                    name="password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    style={{
                      borderColor:
                        formik.errors.password && formik.touched.password
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.password && formik.touched.password
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.password && formik.touched.password && (
                    <p style={{ color: "red" }}>{formik.errors.password}</p>
                  )}
                </div>
              </div>

              <div className="row form-group">
                <div className="col-md-12">
                  <button
                    type="submit"
                    className="btn px-4 text-white"
                    style={{
                      backgroundColor: "#6E3ECD",
                      width: "100%",
                    }}
                  >
                    {loading ? <CircularProgress /> : "log in"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default LogIn;
